module.exports = __webpack_public_path__ + "static/media/construction-image.e46c2fdd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/Construction/construction-image.jpg
// module id = 267
// module chunks = 0